import { createClient } from '@supabase/supabase-js';
import axios, { AxiosRequestConfig } from 'axios';
import supabaseConfig from '../supabaseConfig';

console.log(process.env.REACT_APP_SUPABASE_URL);

export const supabase = createClient(
  'https://gibnkggiuxphkienkxwf.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdpYm5rZ2dpdXhwaGtpZW5reHdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA3OTI0OTEsImV4cCI6MjA0NjM2ODQ5MX0.jzHj8vjuo7KuX4nHi-_tq051mp9quUNKMP0wN8Makj4',
  supabaseConfig,
)
// export const supabaseAnalytics = createClient(
//   process.env.REACT_APP_SUPABASE_ANALYTICS_URL || '',
//   process.env.REACT_APP_SUPABASE_ANALYTICS_ANON_KEY || '',
//   supabaseConfig,
// )
// const headers = {
//   'Content-Type': 'application/json;charset=utf-8',
// }

async function get(url: string, config?: AxiosRequestConfig<any>) {
  const result = await axios.get(url, {
    ...(config ?? {}),
    baseURL: process.env.REACT_APP_FEED_SERVER,
  })
  return result.data
}

async function post(url: string, data: any, config?: AxiosRequestConfig<any>) {
  const result = await axios.post(url, data, {
    ...(config ?? {}),
    baseURL: process.env.REACT_APP_FEED_SERVER,
  })

  return result.data
}

async function cloudPost(url: string, data: any, config?: any) {
  const uploadUrl = `${process.env.REACT_APP_CLOUDINARY_URL}/auto/upload` ?? ''
  const response = await axios.post(
    uploadUrl,
    data,
    config,
  );
  return response.data;
}

const cloud_name = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME ?? ''; // eslint-disable-line
 // eslint-disable-line
const upload_preset = 'posts_preset'; // eslint-disable-line
const sliceSize = 6000000;

export async function processFile(event, cb) {
  const XUniqueUploadId = +new Date();
  const publicId = +new Date();
  const file = event.target.files[0]
  console.log(file)
  if (!file) return {};
  const { size } = file;
  let start = 0;
  let res;
  while (start < size) {
    const end = Math.min(start + sliceSize, size);
    const piece = sliceFile(file, start, end); // eslint-disable-line
   res = await send(piece, start, end - 1, size,XUniqueUploadId, publicId, cb); // eslint-disable-line
    start = end;
  }
  cb(100)
  return res
}

function sliceFile(file, start, end) { // eslint-disable-next-line
  const slice = file.mozSlice ? file.mozSlice : file.webkitSlice ? file.webkitSlice : file.slice ? file.slice : () => { };
  return slice.call(file, start, end);
}

async function callEdgeFunction(
  publicId: string,
  time: string,
  eagerParams: string,
  folder: string,
) {
  try {
    const { data, error } = await supabase.functions.invoke(
      'create-signature',
      {

        body: JSON.stringify({
          publicId, time, eagerParams, folder,
        }),
      },

    )

    if (error) {
      throw new Error(`Error calling Edge function: ${error}`);
    }
    return data;
  } catch (error: any) {
    console.error('Error calling Edge function:', error.message);
    return error;
  }
}

async function send(piece, start, end, size, XUniqueUploadId, publicId, cb) {
  const time = String(Math.floor(Date.now() / 1000));
  const transformation = 'f_mp4' // ,vc_h264|w_260,h_200,c_crop'
  const eagerParams = 't_video_android|t_video_ios|t_video_web'
  const folder = 'videos';
  const { signature } = await callEdgeFunction(publicId, time, eagerParams, folder);
  const formData = new FormData();
  formData.append('file', piece);
  formData.append('upload_preset', upload_preset);
  formData.append('cloud_name', cloud_name);
  formData.append('timestamp', time);
  formData.append('signature', signature);
  formData.append('resource_type', 'video')
  formData.append('folder', 'videos')
  formData.append('public_id', `${publicId}`);
  formData.append('transformation', transformation);
  formData.append('eager_async', 'true')
  formData.append('raw_convert', 'google_speech:srt:vtt');
  formData.append('eager', eagerParams);
  formData.append(
    'api_key',
    process.env.REACT_APP_CLOUDINARY_API_KEY ?? '',
  );

  try {
    const response = await axios.post(`https://api.cloudinary.com/v1_1/${cloud_name}/auto/upload`, formData, {
      headers: {
        'X-Unique-Upload-Id': XUniqueUploadId,
        'Content-Range': `bytes ${start}-${end}/${size}`,
      },
      onUploadProgress: (progress) => {
        const percent = Math.round((100 * (progress.loaded + start)) / size)
        cb(percent > 50 ? percent - 1 : percent)
      },
    });
    console.log(response.data)

    return response.data
  } catch (error) {
    console.error('Error uploading:', error);
  }
  return {}
}

async function uploadMedia(formData: FormData) {
  formData.append('upload_preset', 'ml_default')
  formData.append('folder', 'images')
  const response = await fetch(
    `${process.env.REACT_APP_CLOUDINARY_URL}/upload`,
    {
      method: 'POST',
      body: formData,
    },
  );
  const result = await response.json();
  return result.secure_url
}

// @ts-ignore
export const handleSignInWithGoogle = (response: any) => { // @ts-ignore
  supabase.auth.signInWithIdToken({
    token: response.credential,
    nonce: '', // @ts-ignore
    client_id: response.client_id,
    clientId: response.clientId,
    provider: 'google',
  })
    .then(() => {
      window.location.reload()
    })
}

// @ts-ignore
export const handleSignInWithApple = async (response: any) => {
  const idToken =
    response?.authorization?.id_token ||
    response?.authorization?.idToken;

  if (!idToken) throw new Error('Apple sign-in: missing id_token');

  // IMPORTANT: If you use nonce with Apple, you must:
  // 1) send HASHED nonce to Apple, and
  // 2) send RAW nonce to Supabase here.
  // If you are not using nonce yet, keep it as '' like your Google code.
  const rawNonce = '';

  const { error } = await supabase.auth.signInWithIdToken({
    provider: 'apple',
    token: idToken,
    nonce: rawNonce,
  });

  if (error) throw error;

  window.location.reload();
};

export const cloudApi = { post: cloudPost, uploadMedia }

export const streamApi = { get, post, cloudPost }

export default supabase
